import { render, staticRenderFns } from "./TableRevisionsCompare.vue?vue&type=template&id=4396cb5e&scoped=true"
import script from "./TableRevisionsCompare.vue?vue&type=script&lang=js"
export * from "./TableRevisionsCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4396cb5e",
  null
  
)

export default component.exports